import React from 'react'
import { AlertBlockComponent } from '@mmsg/louie'

export default function SpartaCustomerCount({
  line1,
  line2,
  icon,
  extended,
  spacingValue,
  iconTopLine
}) {
  return line1 ? (
    <div>
      <AlertBlockComponent
        isWarning={false}
        extended={extended ? extended : false}
        heading={line1}
        content={line2}
        icon={icon}
        iconTopLine={iconTopLine}
        spacingValue={spacingValue}
      />
    </div>
  ) : null
}
